import React, { useEffect, useState } from 'react';
import styles from './license-calc.module.scss';
import { DefaultButton } from 'shared/ui';
import {
  ILicenseCalcAmountResult,
  licenseCalcAmount,
} from '../model/license-calc-amount';
import { LicenseEnum } from 'shared/types';
import { IGetLicenseInfoProps } from 'shared/api/business/interfaces/get-license-info.props.interface';
import { LicensePaymentConfirm } from './license-payment-confirm';

interface ILicenseCalcComponentProps {
  fromEmplCount: number;
  toEmplCount: number;
  monthCount: number;
  diffDays: number;
  licType: LicenseEnum;
  License: IGetLicenseInfoProps;
}

export const LicenseCalcComponent: React.FC<ILicenseCalcComponentProps> = ({
  toEmplCount,
  monthCount,
  fromEmplCount,
  diffDays,
  licType,
  License,
}) => {
  const [result, setResult] = useState<ILicenseCalcAmountResult>();
  const [showPaymentConfirm, setShowPaymentConfirm] = useState(false);

  useEffect(() => {
    setResult(
      licenseCalcAmount(
        licType,
        License,
        fromEmplCount,
        toEmplCount,
        monthCount,
        diffDays
      )
    );
  }, [toEmplCount, monthCount]);

  const payment = () => {
    setShowPaymentConfirm(true);
  };

  const bodyItem = (text: string, value: string, valueNoDiscount?: string) => {
    return (
      <div className={styles.body__item}>
        <div className={styles.item__title}>{text}</div>
        {valueNoDiscount && (
          <div className={styles.item__value_no_discount}>
            {valueNoDiscount}
          </div>
        )}
        <div className={styles.item__value}>{value}</div>
      </div>
    );
  };
  return result ? (
    <>
      <div className={styles.license__container}>
        <div className={styles.container__content}>
          <div className={styles.content__top}>
            <div className={styles.top__title}>
              Скидка {result.totalDiscount}%
            </div>
            {result.totalDiffPriceEmpl < 1 ? null : (
              <div className={styles.top__calc_result}>
                <div className={styles.calc_result__title}>
                  Докупка сотрудников
                </div>
                <div className={styles.calc_result__body}>
                  {bodyItem('Новые сотр.', `${result.diffPriceNewEmpl} ₽`)}
                  {bodyItem(
                    'Текущие сотр.',
                    `${result.diffPriceCurrentEmpl} ₽`
                  )}
                  {bodyItem('Всего', `${result.totalDiffPriceEmpl} ₽`)}
                </div>
              </div>
            )}
            <div className={styles.top__calc_result}>
              <div className={styles.calc_result__title}>Докупка месяцев</div>
              <div className={styles.calc_result__body}>
                {bodyItem(
                  'За сотрудника',
                  `${result.monthlyEmployeeDiscPrice} ₽/мес.`,
                  `${result.monthlyEmployeePrice} ₽/мес.`
                )}
                {bodyItem(
                  'Всего',
                  `${result.monthlyTotalDiscPrice} ₽/мес.`,
                  `${result.monthlyTotalPrice} ₽/мес.`
                )}
              </div>
            </div>
          </div>
          <div className={styles.content__bottom}>
            <div className={styles.bottom__button}>
              {result.totalPrice ? (
                result.totalPrice < 0 ? (
                  <DefaultButton
                    buttonText={`Бесплатно`}
                    color="green"
                    onClick={payment}
                  ></DefaultButton>
                ) : (
                  <DefaultButton
                    buttonText={`Оплатить ${result.totalPrice} ₽`}
                    color="green"
                    onClick={payment}
                  ></DefaultButton>
                )
              ) : null}
            </div>
          </div>
        </div>
      </div>
      {showPaymentConfirm && (
        <LicensePaymentConfirm
          toEmplCount={toEmplCount}
          monthCount={monthCount}
          totalPrice={result.totalPrice}
          totalDiscount={result.totalDiscount}
          licType={licType}
          onClose={() => setShowPaymentConfirm(false)}
        />
      )}
    </>
  ) : null;
};
